import * as React from "react";
import ReactPDF, { View, Text } from "@react-pdf/renderer";
import { TPublicationsReportReportingPeriodPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportingPeriodPresentationModel";
import PublicationsReportPDFReportsGrid from "./PublicationsReportPDFReportsGrid";

const PublicationsReportPDFReportingPeriod = ({
  translate,
  reportingPeriod,
  styles
}: {
  translate: any;
  reportingPeriod: TPublicationsReportReportingPeriodPresentationModel;
  styles: ReactPDF.Styles;
}) => {
  return (
    <View style={styles.titleCol}>
      <Text style={{ ...styles.subtitle, marginBottom: 1 }}>
        {`${translate("publications_report.reporting_period.name")}: ${
          reportingPeriod.reportingPeriodName
        }`}
      </Text>
      <Text style={styles.regularText}>
        {`${translate(
          "publications_report.reporting_period.additional_evaluation"
        )}: ${
          reportingPeriod.additionalEvaluationIndicator
            ? translate("basic.yes")
            : translate("basic.no")
        }`}
      </Text>
      <Text style={styles.regularText}>
        {`${translate(
          "publications_report.reporting_period.additional_evaluation_status"
        )}: ${reportingPeriod.additionalEvaluationStatus}`}
      </Text>
      <Text style={styles.regularText}>{`${translate(
        "publications_report.reporting_period.additional_evaluation_date"
      )}: ${reportingPeriod.additionalEvaluationDate || ""}`}</Text>
      <PublicationsReportPDFReportsGrid
        translate={translate}
        reports={reportingPeriod.reports}
        styles={styles}
      />
    </View>
  );
};

export default PublicationsReportPDFReportingPeriod;
